<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <Loading :isOpen="isLoading" />
  </div>
</template>

<script>
import { 
  mapGetters,
  mapActions,
} from 'vuex';

import Loading from "@/components/Loading.vue";

export default {
  name: "app",
  components: {
    Loading
  },
  computed: {
    ...mapGetters([
      'isLoading'
    ])
  },
};
</script>

<style lang="scss">
@import './scss/app.scss';

@font-face {
  font-family: "icons";
  src: url("../public/fonts/icons.eot")
      format("embedded-opentype"),
    url("../public/fonts/icons.woff2?8d8652a3ca5aba96dcfdacc2021d02f8")
      format("woff2"),
    url("../public/fonts/icons.woff?8d8652a3ca5aba96dcfdacc2021d02f8")
      format("woff"),
    url("../public/fonts/icons.ttf?8d8652a3ca5aba96dcfdacc2021d02f8")
      format("truetype"),
    url("../public/fonts/icons.svg?8d8652a3ca5aba96dcfdacc2021d02f8#icons")
      format("svg");
}

i[class^="icon-"]:before,
i[class*=" icon-"]:before {
  font-family: icons !important;
  font-style: normal;
  font-weight: normal !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-1:before {
  content: "\f101";
}
.icon-2:before {
  content: "\f102";
}
.icon-3:before {
  content: "\f103";
}
.icon-eye_close:before {
  content: "\f104";
}
.icon-eye_open:before {
  content: "\f105";
}
.icon-facebook:before {
  content: "\f106";
}
.icon-google:before {
  content: "\f107";
}
.icon-ok:before {
  content: "\f108";
}
.icon-password:before {
  content: "\f109";
}
.icon-plurk:before {
  content: "\f10a";
}
.icon-twitter:before {
  content: "\f10b";
}
</style>
